import {setCookie, getCookie} from "./cookie";

export const setToken = (token) => {
    /***
     * remove old token
     * document.cookie = "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
     * document.cookie = "refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
     * set new token
     ***/
    setCookie("accessToken", token.access_token, ((token.expires_in - 30) * 1000));
    setCookie("refreshToken", token.refresh_token, (180*24*60*60*1000));
};
export const getToken = (tokenName) => {
    return getCookie(tokenName);
};